export class DialogProps {
  constructor(t) {
    this.visible = {
      type: Boolean,
      default: false,
    };
    this.edit = {
      type: Boolean,
      default: false,
    };
    this.content = {
      type: Object,
      default: () => new t(),
    };
  }
  static Build() {
    return new DialogProps(Object);
  }
}
